import React from "react";
import { Grid, Header, Label, Icon, Statistic } from "semantic-ui-react";
import moment from "moment";

const CatalogLog = ({ log, at, user }) => {
	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Column style={{ padding: 40, height: "93vh" }}>
				<Header as="h2">
					<Icon name="download" />
					<Header.Content>
						Import du {moment(at).format("DD/MM/YYYY HH:mm")}
						<Header.Subheader>par {user}</Header.Subheader>
					</Header.Content>
				</Header>

				<div style={{ overflowY: "auto", height: "100%" }}>
					{log.all > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon name="syringe" />
									{log.all}
								</Statistic.Value>
								<Statistic.Label>analyses retournées par le catalogue</Statistic.Label>
							</Statistic>
							<br />- Analyses créées : {log.created.length} :{" "}
							{log.created.map((e) => (
								<Label key={"ana-created-" + e}>{e}</Label>
							))}
							<br />- Analyses mises à jour : {log.updated.length} :{" "}
							{log.updated.map((e) => (
								<Label key={"ana-updated-" + e}>{e}</Label>
							))}
							<br />- Analyses non modifiées : {log.sameVersion.length} :{" "}
							{log.sameVersion.map((e) => (
								<Label key={"ana-sameVersion-" + e}>{e}</Label>
							))}
						</>
					)}
					{log.all === 0 && (
						<>
							<Header as="h4" icon="syringe" content="Aucune analyse retournée par le catalogue" />{" "}
						</>
					)}
					{log.tubes > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon name="flask" />
									{log.tubes}
								</Statistic.Value>
								<Statistic.Label>tubes retournés par le catalogue</Statistic.Label>
							</Statistic>
							<br />- Tubes créés : {log.tubesCreated.length} :{" "}
							{log.tubesCreated.map((e) => (
								<Label key={"tub-created-" + e}>{e}</Label>
							))}
							<br />- Tubes modifiés : {log.tubesUpdated.length} :{" "}
							{log.tubesUpdated.map((e) => (
								<Label key={"tubesUpdated-" + e}>{e}</Label>
							))}
							<br />- Tubes non modifiés : {log.tubesNotUpdated.length} :{" "}
							{log.tubesNotUpdated.map((e) => (
								<Label key={"tubesNotUpdated-" + e}>{e}</Label>
							))}
						</>
					)}
					{log.tubes === 0 && (
						<>
							<Header as="h4" icon="flask" content="Aucun tube retourné par le catalogue" />{" "}
						</>
					)}

					{log.pictos > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon name="picture" />
									{log.pictos}
								</Statistic.Value>
								<Statistic.Label>pictos retournés par le catalogue</Statistic.Label>
							</Statistic>
							<br />- Pictos créés : {log.pictoCreated.length} :{" "}
							{log.pictoCreated.map((e) => (
								<Label key={"pictoCreated-" + e}>{e}</Label>
							))}
							<br />- Pictos modifiés : {log.pictoUpdated.length} :{" "}
							{log.pictoUpdated.map((e) => (
								<Label key={"pictoUpdated-" + e}>{e}</Label>
							))}
							<br />- Pictos non modifiés : {log.pictoNotUpdated.length} :{" "}
							{log.pictoNotUpdated.map((e) => (
								<Label key={"pictoNotUpdated-" + e}>{e}</Label>
							))}
						</>
					)}
					{log.pictos === 0 && (
						<>
							{" "}
							<Header as="h4" icon="picture" content="Aucun picto retourné par le catalogue" />
						</>
					)}

					{log.motivations > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon name="check square outline" />
									{log.motivations}
								</Statistic.Value>
								<Statistic.Label>motivations retournées par le catalogue</Statistic.Label>
							</Statistic>
							<br />- Motivations créées : {log.motivationsCreated.length} :{" "}
							{log.motivationsCreated.map((e) => (
								<Label key={"motivationsCreated-" + e.id}>
									{e.code_agency}: {e.label}
								</Label>
							))}
							<br />- Motivations modifiées : {log.motivationsUpdated.length} :{" "}
							{log.motivationsUpdated.map((e) => (
								<Label key={"pictoUpdated-" + e.id}>
									{e.code_agency}: {e.label}
								</Label>
							))}
						</>
					)}
					{log.motivations === 0 && (
						<>
							<br /> <Header as="h4" icon="check square outline" content="Pas de motivations retournées par le catalogue" />
						</>
					)}
					{log.errors && log.errors.length > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon color="red" name="remove circle" />
									{log.errors.length}
								</Statistic.Value>
								<Statistic.Label>erreurs rencontrées durant l'import</Statistic.Label>
							</Statistic>
							<br />
							{log.errors.map((e, i) => (
								<Label key={"errors-" + i}>{e}</Label>
							))}
						</>
					)}
					{log.warning && log.warning.length > 0 && (
						<>
							<br />
							<Statistic horizontal>
								<Statistic.Value>
									{" "}
									<Icon color="yellow" name="warning circle" />
									{log.warning.length}
								</Statistic.Value>
								<Statistic.Label>warnings rencontrés durant l'import</Statistic.Label>
							</Statistic>
							<br />
							{log.warning.map((e, i) => (
								<Label key={"warning-" + i}>{e}</Label>
							))}
						</>
					)}
					<br />
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default CatalogLog;
